import { useEffect, useState } from "react";

export const LoadKasadaIntegration = () => {
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      const script = document.createElement("script");
      script.innerHTML =
        'document.addEventListener("kpsdk-load", function () { window.KPSDK.configure([{ protocol: "https", method: "*", domain: window.location.host, path: "/api/orders/v3/unauth/bundled/order" }, { protocol: "https", method: "POST", domain: window.location.host, path: "/v1/identity-verification/verify" }, { protocol: "https", method: "*", domain: window.location.host, path: "/lpg/offers/api/v1/*"}]) })';
      (document.head as HTMLHeadElement).appendChild(script);

      const script2 = document.createElement("script");
      script2.setAttribute(
        "src",
        "/149e9513-01fa-4fb0-aad4-566afd725d1b/2d206a39-8ed7-437e-a3be-862e0f06eea3/p.js"
      );
      (document.head as HTMLHeadElement).appendChild(script2);
    }
  }, []);
  return null;
};
